
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { setupScrollWatcher } from '@xt/client/utils/scroll'

@Observer
@Component({
  components: {
    HeaderImage
  }
})
export default class PlaybackPageView extends Vue {
  ob: MutationObserver | null = null

  clearScrollEvent: null | (() => void) = null

  get PageStore() {
    return this.$store.$genseePlayback
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  @Ref('chat-container')
  chatContainer: HTMLDivElement

  created() {}
  mounted() {
    this.$nextTick(() => {
      this.ob = new MutationObserver(list => {
        if (this.PageStore.commentScrollLock) {
          console.warn('有新评论进来但是滚动被锁定')
          return
        }

        list.forEach(item => {
          if (item.addedNodes.length > 0) {
            ;(item.addedNodes[0] as HTMLDivElement).scrollIntoView({ block: 'end', behavior: 'smooth' })
          }
        })
      })
      this.ob.observe(this.chatContainer, { childList: true, attributes: false })
    })

    if (this.chatContainer) {
      this.clearScrollEvent = setupScrollWatcher(this.chatContainer, {
        threshold: 50,
        gap: 20,
        onReachBottom: () => {
          if (this.PageStore.commentScrollLock === false) return

          console.warn('触发滚动到底部事件')
          this.PageStore.updateCommentScrollLock(false)
          this.PageStore.clearUnReadCommentCount()
        },
        onReverseScroll: () => {
          if (this.PageStore.commentScrollLock === true) return
          console.warn('触发反响滚动到阈值事件')

          this.PageStore.updateCommentScrollLock(true)
        }
      })
    }
  }
  destroyed() {
    if (this.clearScrollEvent) {
      this.clearScrollEvent()
    }

    if (this.ob) {
      this.ob.disconnect()
    }
  }
}
